import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";

export interface ADIUserRoleParameter extends ApiParameter {
    currentUserRole: string;
}

export interface ADIUserRoleModel {
    currentUserRole: string;
}

type HandlerType = CustomApiHandler<ADIUserRoleParameter, ADIUserRoleModel>;

export const DispatchADIUserRole: HandlerType = props => {
    props.dispatch({
        type: "HomePage/setADIUserRole",
        currentRole: props.parameter.currentUserRole,
    });
};

export const chain = [DispatchADIUserRole];

const setADIUserRole = createHandlerChainRunner(chain, "setADIUserRole");
export default setADIUserRole;
